import { render } from "./addemployees.vue?vue&type=template&id=3ce26ba2"
import script from "./addemployees.vue?vue&type=script&lang=js"
export * from "./addemployees.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__